import { Theme } from '@mui/material';
import { SxProps } from '@mui/material/styles';

export const getStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: { xs: theme.spacing(5), sm: theme.spacing(6) },
  },
  title: { px: { xs: theme.spacing(5), sm: theme.spacing(6) } },
  shortLabel: { display: { xs: 'block', sm: 'none' } },
  longLabel: { display: { xs: 'none', sm: 'block' } },
});
